@file:OptIn(InternalResourceApi::class)

package soccerconvertscript.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/soccerconvertscript.composeapp.generated.resources/"

@delegate:ResourceContentHash(301_793_218)
internal val Res.drawable.ic_calendar_add: DrawableResource by lazy {
      DrawableResource("drawable:ic_calendar_add", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_calendar_add.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_049_143_942)
internal val Res.drawable.ic_calendar_add_2: DrawableResource by lazy {
      DrawableResource("drawable:ic_calendar_add_2", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_calendar_add_2.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_554_914_525)
internal val Res.drawable.ic_open_window: DrawableResource by lazy {
      DrawableResource("drawable:ic_open_window", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_open_window.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_031_465_254)
internal val Res.drawable.ic_paste: DrawableResource by lazy {
      DrawableResource("drawable:ic_paste", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_paste.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-88_592_418)
internal val Res.drawable.ic_select_all: DrawableResource by lazy {
      DrawableResource("drawable:ic_select_all", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_select_all.svg", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("ic_calendar_add", Res.drawable.ic_calendar_add)
  map.put("ic_calendar_add_2", Res.drawable.ic_calendar_add_2)
  map.put("ic_open_window", Res.drawable.ic_open_window)
  map.put("ic_paste", Res.drawable.ic_paste)
  map.put("ic_select_all", Res.drawable.ic_select_all)
}
